import React from 'react';
import SafeIcon from '../common/SafeIcon';

export default function FAQ() {
  const faqs = [
    { q: 'O que significa Mini Mental?', a: 'É o Mini Exame do Estado Mental (MEEM), um teste de rastreio cognitivo.' },
    { q: 'Qual a pontuação máxima?', a: 'A pontuação máxima é 30 pontos.' },
    { q: 'Uma pontuação baixa confirma Alzheimer?', a: 'Não. Pontuações baixas indicam necessidade de investigação clínica, mas não definem a causa do declínio.' },
    { q: 'Posso fazer o teste sozinho online?', a: 'A aplicação exige supervisão profissional para ser válida. Esta página apenas calcula a pontuação de um teste já realizado.' },
    { q: 'O site salva minha pontuação?', a: 'Não. O cálculo é local e privado.' }
  ];

  return (
    <section id="perguntas" className="max-w-[800px] mx-auto px-4 py-12 border-t border-[var(--border-strong)]">
      <h2 className="mb-6">Perguntas frequentes</h2>
      <div className="divide-y divide-[var(--border)] border-y border-[var(--border)]">
        {faqs.map((faq, idx) => (
          <details key={idx} className="group py-1">
            <summary className="flex min-h-12 cursor-pointer list-none items-center justify-between gap-4 font-semibold text-[var(--primary)]">
              {faq.q}
              <SafeIcon name="ChevronDown" className="h-5 w-5 shrink-0 text-[var(--text-muted)] transition-transform group-open:rotate-180" />
            </summary>
            <div className="max-w-[68ch] pb-4 pr-8 leading-relaxed text-[var(--text-muted)]">
              {faq.a}
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}
